import { helpers } 		from './sites/helpers.js';
import { unitab } 		from './sites/components/unitab.js';
import { filter } 		from './sites/components/filter.js';
import { animations } 	from './sites/components/animations.js';

window.sites = {
	globals: {},

	init: function () {
		var self = this;

		unitab.init();
		filter.init();
		
		animations.init();
	},

	onresize() {
		var self = this;

		animations.refresh();
	},

	onscroll(position, previusPosition) {
		var self = this;

		animations.refresh();
	},
};

jQuery(document).ready(function ($) {
	sites.init();
});

window.addEventListener('scroll', function (e) {
	sites.onscroll();
});

window.addEventListener('resize', function (e) {
	sites.onresize();
});